import { render } from "./OrcamentoInformacao.vue?vue&type=template&id=112db782&scoped=true"
import script from "./OrcamentoInformacao.vue?vue&type=script&lang=js"
export * from "./OrcamentoInformacao.vue?vue&type=script&lang=js"

import "./OrcamentoInformacao.vue?vue&type=style&index=0&id=112db782&scoped=true&lang=css"

import exportComponent from "C:\\Users\\guilherme.g.adm\\Documents\\FDVSolution\\FDVSolution\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-112db782"]])

export default __exports__